import {getConfigData, serverOrClient} from '@udemy/shared-utils';

import {formatNumber} from './numeral';

// Please keep these implementations in sync with the backend equivalent:
// udemy/site_stats/templatetags/site_stats.py.

export function getOrgNumericSiteStat(
    statName: string,
    udDataOverrides: Record<string, unknown> = {},
) {
    const siteStats =
        (udDataOverrides.site_stats as typeof serverOrClient.global.UD.site_stats) ??
        serverOrClient.global.UD.site_stats;
    const stat = siteStats.organizations[statName];
    return typeof stat === 'number' ? formatNumber(stat) : stat;
}

export function getNumericSiteStat(
    statName: string,
    udDataOverrides: Record<string, unknown> = {},
) {
    const udConfig = udDataOverrides.Config ?? getConfigData();
    const siteStats =
        (udDataOverrides.site_stats as typeof serverOrClient.global.UD.site_stats) ??
        serverOrClient.global.UD.site_stats;
    let stat = siteStats.default[statName];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((udConfig as any).brand.has_organization && statName in siteStats.organizations) {
        stat = siteStats.organizations[statName];
    }
    return typeof stat === 'number' ? formatNumber(stat) : stat;
}
